// extracted by mini-css-extract-plugin
module.exports = {"cover":"cover_cover__UOz_O"};